import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../firebase.config';
import { MultiLevelSidebar } from '../Components/Layout/Sidebar';
import EventList from '../Components/Events/EventList';

const Events = () => {
    const [events, setEvents] = useState([])
  const fetchProperties = async () =>{
    const querySnapshot = await getDocs(collection(db, "events"));
    querySnapshot.forEach((doc) => {
     setEvents((prev)=>[...prev,{
      id:doc.id,
      ...doc.data()
     }])
   
  
    });
  }
  const deleteProperty = async (id) =>{
     await deleteDoc(doc(db, "events", id))
    window.location.reload()
  
  }
  useEffect(() => {
   fetchProperties()
  }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <EventList events={events} deleteEvent={deleteProperty} />
    </div>
  )
}

export default Events